import Layout from '@/components/layout/Layout';

export const Privacy = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 max-w-4xl py-12 md:py-16">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-2">
          Politica de Privacidade
        </h1>
        <p className="text-slate-500 text-sm mb-8">Ultima atualizacao: 01 de fevereiro de 2026</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
          <p>
            O <strong>Carvalho Comercio</strong> ("nos", "nosso") opera o site carvalhocomercio.com.br e se compromete a proteger a privacidade dos seus usuarios. Esta Politica de Privacidade descreve como coletamos, usamos e protegemos suas informacoes pessoais quando voce utiliza nosso site.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">1. Informacoes que Coletamos</h2>
          <p>Coletamos os seguintes tipos de informacoes:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Dados de navegacao:</strong> Paginas visitadas, tempo de permanencia, cliques em produtos e ofertas, tipo de dispositivo e navegador utilizado.</li>
            <li><strong>Dados fornecidos voluntariamente:</strong> Nome e numero de telefone, apenas quando voce preenche o formulario para entrar no nosso grupo de ofertas no WhatsApp.</li>
            <li><strong>Cookies:</strong> Pequenos arquivos armazenados no seu navegador para melhorar a experiencia de uso e lembrar suas preferencias (como favoritos).</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">2. Como Usamos suas Informacoes</h2>
          <p>As informacoes coletadas sao utilizadas exclusivamente para:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Apresentar ofertas e produtos relevantes ao seu perfil de interesse.</li>
            <li>Enviar informacoes sobre promocoes atraves do nosso canal no WhatsApp (somente com seu consentimento).</li>
            <li>Analisar o desempenho do site e melhorar a experiencia de navegacao.</li>
            <li>Gerar estatisticas anonimas sobre o uso do site.</li>
          </ul>
          <p><strong>Nao vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de marketing.</strong></p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">3. Links de Afiliados</h2>
          <p>
            Este site contem links de afiliados para plataformas parceiras como Amazon, Shopee, Mercado Livre, Temu, Shein, Hotmart e outras. Quando voce clica em um desses links e realiza uma compra, podemos receber uma pequena comissao sem nenhum custo adicional para voce. Essa comissao nos ajuda a manter o site funcionando e trazer as melhores ofertas diariamente.
          </p>
          <p>
            Ao clicar em um link de afiliado, voce sera redirecionado para o site da loja parceira, que possui sua propria politica de privacidade. Recomendamos que voce leia a politica de cada loja antes de realizar uma compra.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">4. Cookies e Tecnologias Similares</h2>
          <p>
            Utilizamos cookies essenciais para o funcionamento do site e cookies de preferencia para salvar seus favoritos. Voce pode configurar seu navegador para bloquear cookies, porem isso pode afetar algumas funcionalidades.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">5. Seguranca dos Dados</h2>
          <p>
            Adotamos medidas tecnicas e organizacionais para proteger suas informacoes pessoais, incluindo criptografia de dados em transito (HTTPS/SSL), sanitizacao de inputs contra ataques XSS e limitacao de taxa de requisicoes para prevenir abusos.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">6. Seus Direitos (LGPD)</h2>
          <p>De acordo com a Lei Geral de Protecao de Dados (Lei no 13.709/2018), voce tem direito a:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Confirmar a existencia de tratamento de seus dados pessoais.</li>
            <li>Acessar seus dados pessoais.</li>
            <li>Solicitar a correcao de dados incompletos ou desatualizados.</li>
            <li>Solicitar a exclusao de seus dados pessoais.</li>
            <li>Revogar o consentimento dado para o tratamento de dados.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">7. Contato</h2>
          <p>
            Para exercer seus direitos ou tirar duvidas sobre esta politica, entre em contato conosco pelo e-mail: <a href="mailto:carvalhocomercio7@gmail.com" className="text-orange-600 font-medium hover:underline">carvalhocomercio7@gmail.com</a>
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">8. Alteracoes nesta Politica</h2>
          <p>
            Reservamo-nos o direito de atualizar esta Politica de Privacidade a qualquer momento. Recomendamos que voce revise esta pagina periodicamente para estar ciente de quaisquer alteracoes.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
